<script setup>

import { useRouter } from 'vue-router';
import { useSessionStore } from '@lib/pp-shop-lib/stores';
import { storeToRefs } from 'pinia';
import { _ } from 'lodash';

const router = useRouter();
const sessionStore = useSessionStore();
const { checkout } = storeToRefs(sessionStore);

checkout.value.section = "cart";

router.push("/shop/checkout")

</script>
